import React, { createContext, useState } from "react";
import { useData } from "../general/DataContext"; 

export const BrandsContext = createContext();

export const BrandsProvider = ({ children }) => {
  const { statusdata } = useData(); 

  const [brandsList, setBrandsList] = useState([
    {
      id: 1,
      name: "Brand A",
      description: "Brand A açıklaması",
      status: statusdata[0], 
    },
    {
      id: 2,
      name: "Brand B",
      description: "Brand B açıklaması",
      status: statusdata[1], 
    },
  ]);

  // Marka ekleme
  const addBrand = (brand) => {
    const newId =
      brandsList.length > 0
        ? Math.max(...brandsList.map((b) => b.id)) + 1
        : 1;
    const newBrand = { ...brand, id: newId };
    setBrandsList((prev) => [...prev, newBrand]);
  };

  // Marka güncelleme
  const updateBrand = (id, updatedData) => {
    setBrandsList((prev) =>
      prev.map((b) => (b.id === id ? { ...b, ...updatedData } : b))
    );
  };

  // Marka silme
  const deleteBrand = (id) => {
    setBrandsList((prev) => prev.filter((b) => b.id !== id));
  };

  return (
    <BrandsContext.Provider
      value={{
        brandsList,
        addBrand,
        updateBrand,
        deleteBrand,
        statusdata,
      }}
    >
      {children}
    </BrandsContext.Provider>
  );
};
